var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn"},[_c('a-button',{attrs:{"block":""},on:{"click":function($event){$event.stopPropagation();return _vm.moduleEnter.apply(null, arguments)}}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('renew'))))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }